import { scorT, getScorLocale } from 'i18n/scorLocale';
import { normalizeScorLineBreaks } from './scorText';

export const formatScorFaqAnswer = (answer: string, pricing?: ApiScorPricing | null): string => {
  const prices: Record<string, number | null | undefined> = {
    exclusive_days: pricing?.subscription?.exclusive_days,
    reports_included: pricing?.subscription?.reports_included,
    price_sub: pricing?.subscription?.price_month,
    price_report: pricing?.services?.find((service) => service.code === 'report')?.price,
    price_express: pricing?.services?.find((service) => service.code === 'express')?.price,
  };

  return normalizeScorLineBreaks(answer)
    .replace(/\{(price_sub|price_report|price_express|exclusive_days|reports_included)\}/g, (_, key: string) => {
      const price = prices[key];

      return typeof price === 'number' && Number.isFinite(price)
        ? new Intl.NumberFormat(getScorLocale()).format(price)
        : key.startsWith('price_') ? scorT('onRequest') : '—';
    });
};
